import { BrowserRouter, useLocation } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { useEffect } from "react";
import ChatWidget from "@/components/feature/ChatWidget";
import AgencyPublicPage from "@/components/feature/AgencyPublicPage";
import ContractPublicPage from "@/components/feature/ContractPublicPage";

const CONTRACT_OPEN_URL = "/documents/light-media-contract.html";
const CONTRACT_DOWNLOAD_URL = "/documents/light-media-contract.doc";
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function ContractLinks() {
  const { pathname } = useLocation();

  useEffect(() => {
    const patchContractLinks = () => {
      const heading = Array.from(document.querySelectorAll("h3")).find(
        (node) => node.textContent?.trim() === "Договор на оказание услуг",
      ) as HTMLElement | undefined;

      if (!heading) return;

      let card: HTMLElement | null = heading.parentElement;
      while (
        card &&
        !(card.textContent?.includes("Открыть") && card.textContent?.includes("Скачать"))
      ) {
        card = card.parentElement;
      }

      if (!card) return;

      const links = Array.from(card.querySelectorAll("a")) as HTMLAnchorElement[];
      const openLink = links.find((link) => link.textContent?.includes("Открыть"));
      const downloadLink = links.find((link) => link.textContent?.includes("Скачать"));

      if (openLink) {
        openLink.href = CONTRACT_OPEN_URL;
        openLink.target = "_blank";
        openLink.rel = "noopener noreferrer";
        openLink.removeAttribute("download");
      }

      if (downloadLink) {
        downloadLink.href = CONTRACT_DOWNLOAD_URL;
        downloadLink.removeAttribute("target");
        downloadLink.setAttribute(
          "download",
          "ЛАЙТ МЕДИА - Договор на оказание услуг.doc",
        );
      }
    };

    patchContractLinks();

    const observer = new MutationObserver(patchContractLinks);
    observer.observe(document.body, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, [pathname]);

  return null;
}

function RoutedContent() {
  const { pathname } = useLocation();
  const agencyPublic = pathname.startsWith('/verification/') || pathname.startsWith('/cabinet/') || pathname.startsWith('/registration/');
  const contractPublic = pathname.startsWith('/contract/');

  return (
    <>
      <ScrollToTop />
      {!contractPublic && <ContractLinks />}
      {contractPublic ? (
        <ContractPublicPage />
      ) : agencyPublic ? (
        <AgencyPublicPage />
      ) : (
        <>
          <AppRoutes />
          <ChatWidget />
        </>
      )}
    </>
  );
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <RoutedContent />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
